import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff, CheckCircle } from "@mui/icons-material";
import api from "../../api";
import util from "../../utils/utilsFunctions";

const opcionesBanco = [
  { value: "", label: "-- Seleccione --" },
  { value: "Banco Santander", label: "Banco Santander" },
  { value: "Scotiabank Azul", label: "Scotiabank Azul" },
  { value: "Banco BICE", label: "Banco BICE" },
  { value: "Banco Internacional", label: "Banco Internacional" },
  { value: "Banco Itaú", label: "Banco Itaú" },
  {
    value: "Banco de Chile / Edwards-Citi",
    label: "Banco de Chile / Edwards-Citi",
  },
  { value: "Corpbanca", label: "Corpbanca" },
  {
    value: "Banco Crédito e Inversiones",
    label: "Banco Crédito e Inversiones",
  },
  { value: "Banco Estado", label: "Banco Estado" },
  { value: "Banco Falabella", label: "Banco Falabella" },
  { value: "Banco Security", label: "Banco Security" },
  { value: "Scotiabank", label: "Scotiabank" },
  { value: "Rabobank", label: "Rabobank" },
  { value: "HSBC Bank", label: "HSBC Bank" },
  { value: "Banco Ripley", label: "Banco Ripley" },
  { value: "Banco Paris", label: "Banco Paris" },
  { value: "Banco Consorcio", label: "Banco Consorcio" },
  { value: "Coopeuch", label: "Coopeuch" },
  { value: "Prepago Los Heroes", label: "Prepago Los Heroes" },
  { value: "Tenpo Prepago S.A", label: "Tenpo Prepago S.A" },
];

const opcionesTipoCuentaBancaria = [
  { value: "", label: "-- Seleccione --" },
  { value: "Cuenta Corriente", label: "Cuenta Corriente" },
  { value: "Cuenta Vista", label: "Cuenta Vista" },
  { value: "Chequera Electrónica", label: "Chequera Electrónica" },
  { value: "Cuenta de Ahorro", label: "Cuenta de Ahorro" },
];

const opcionesMedioPago = [
  { value: "", label: "-- Seleccione --" },
  { value: "Boleta", label: "Boleta" },
  { value: "Factura", label: "Factura" },
];

const FormUsuarioFields = ({
  values,
  errors = {},
  touched = {},
  handleChange,
  handleBlur,
  setFieldValue,
  isEdit = false,
  itemInmobiliarias = [],
  usuario = null,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [proyectosData, setProyectosData] = useState([]);
  const [loadingProyectos, setLoadingProyectos] = useState(false);

  let userLogueado = null;
  try {
    userLogueado = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    userLogueado = null;
  }

  const tipoCuentaLogueado = userLogueado ? userLogueado.tipoCuenta : 0;

  const cargaListaProyectos = async (inmobiliariaId) => {
    if (!inmobiliariaId) {
      setProyectosData([]);
      return;
    }
    setLoadingProyectos(true);
    try {
      const res = await api.getProyectos(inmobiliariaId);
      if (res && res.estado === 1 && Array.isArray(res.data) && res.data.length > 0) {
        setProyectosData(res.data.map((x) => ({ value: x.id, label: x.nombre })));
      } else {
        setProyectosData([]);
      }
    } catch (error) {
      console.error("FormUsuarioFields -> cargaListaProyectos -> error", error);
      setProyectosData([]);
    } finally {
      setLoadingProyectos(false);
    }
  };

  useEffect(() => {
    if (values.InmobiliariaId) {
      cargaListaProyectos(values.InmobiliariaId);
    }
  }, [values.InmobiliariaId]);

  const handleCheckProyecto = (proyectoId, checked) => {
    const currentList = Array.isArray(values.ProyectosInmobiliariosId)
      ? values.ProyectosInmobiliariosId
      : [];
    if (checked) {
      setFieldValue("ProyectosInmobiliariosId", [...currentList, proyectoId]);
    } else {
      setFieldValue(
        "ProyectosInmobiliariosId",
        currentList.filter((id) => id !== proyectoId)
      );
    }
  };

  const listaInmobiliariasFormateada = Array.isArray(itemInmobiliarias)
    ? itemInmobiliarias.map((i) =>
        typeof i === "object" && i.id
          ? { value: i.id, label: i.nombre || i.label }
          : i
      )
    : [];

  const tipoCuentaOps =
    tipoCuentaLogueado !== 10
      ? [
          { value: "", label: "--Seleccione--" },
          { value: 0, label: "Administrador" },
          { value: 1, label: "Usuario Web" },
          { value: 3, label: "Fotografo" },
          { value: 4, label: "Anfitrión" },
          { value: 5, label: "Agente" },
          { value: 6, label: "Administrador Inmobiliario" },
          { value: 9, label: "Jefe de Ventas" },
          { value: 10, label: "Broker" },
        ]
      : [
          { value: "", label: "--Seleccione--" },
          { value: 1, label: "Usuario Web" },
        ];

  const handleRutChange = (e) => {
    const formatted = util.formatRut(e.target.value);
    setFieldValue("Rut", formatted);
  };

  const cleanRutVal = util.cleanRut(values.Rut || "");
  const isRutComplete = cleanRutVal.length >= 8;
  const isRutValid = Boolean(values.Rut && util.validate(values.Rut));
  const isRutError = Boolean(
    (touched.Rut && errors.Rut) || (isRutComplete && !isRutValid)
  );

  const rutHelperText = isRutError
    ? errors.Rut || "Rut no valido"
    : isRutValid
    ? "RUT válido"
    : touched.Rut && errors.Rut
    ? errors.Rut
    : "";

  return (
    <Paper elevation={0} sx={{ p: 3, mb: 3, backgroundColor: "#fff" }}>
      <Typography variant="h6" sx={{ mb: 2, color: "#333", fontWeight: 600 }}>
        Información Personal y Cuenta
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Nombres"
            name="Nombres"
            value={values.Nombres || ""}
            onChange={handleChange}
            error={touched.Nombres && Boolean(errors.Nombres)}
            helperText={touched.Nombres && errors.Nombres}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Apellidos"
            name="Apellidos"
            value={values.Apellidos || ""}
            onChange={handleChange}
            error={touched.Apellidos && Boolean(errors.Apellidos)}
            helperText={touched.Apellidos && errors.Apellidos}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Rut"
            name="Rut"
            value={values.Rut || ""}
            onChange={handleRutChange}
            onBlur={handleBlur}
            error={isRutError}
            helperText={rutHelperText}
            FormHelperTextProps={{
              sx: { color: isRutValid && !isRutError ? "#2e7d32" : undefined },
            }}
            InputProps={{
              endAdornment: isRutValid ? (
                <InputAdornment position="end">
                  <CheckCircle color="success" fontSize="small" />
                </InputAdornment>
              ) : null,
            }}
            placeholder="12.345.678-5"
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="date"
            label="Fecha Nacimiento"
            name="FechaNacimiento"
            value={
              values.FechaNacimiento
                ? new Date(values.FechaNacimiento).toISOString().split("T")[0]
                : ""
            }
            onChange={(e) => setFieldValue("FechaNacimiento", e.target.value)}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Teléfono"
            name="Telefono"
            value={values.Telefono || ""}
            onChange={handleChange}
            error={touched.Telefono && Boolean(errors.Telefono)}
            helperText={touched.Telefono && errors.Telefono}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Dirección"
            name="Direccion"
            value={values.Direccion || ""}
            onChange={handleChange}
            error={touched.Direccion && Boolean(errors.Direccion)}
            helperText={touched.Direccion && errors.Direccion}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small" error={touched.TipoCuenta && Boolean(errors.TipoCuenta)}>
            <InputLabel id="tipo-cuenta-label">Tipo Cuenta</InputLabel>
            <Select
              labelId="tipo-cuenta-label"
              name="TipoCuenta"
              value={values.TipoCuenta !== undefined ? values.TipoCuenta : ""}
              label="Tipo Cuenta"
              onChange={handleChange}
            >
              {tipoCuentaOps.map((op) => (
                <MenuItem key={op.value} value={op.value}>
                  {op.label}
                </MenuItem>
              ))}
            </Select>
            {touched.TipoCuenta && errors.TipoCuenta && (
              <FormHelperText>{errors.TipoCuenta}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Correo electrónico"
            name="Email"
            type="email"
            value={values.Email || ""}
            onChange={handleChange}
            error={touched.Email && Boolean(errors.Email)}
            helperText={touched.Email && errors.Email}
            variant="outlined"
            size="small"
          />
        </Grid>

        {(values.TipoCuenta === 5 || values.TipoCuenta === 6) && (
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="inmobiliaria-label">Inmobiliaria</InputLabel>
              <Select
                labelId="inmobiliaria-label"
                name="InmobiliariaId"
                value={values.InmobiliariaId || ""}
                label="Inmobiliaria"
                onChange={(e) => {
                  setFieldValue("InmobiliariaId", e.target.value);
                  cargaListaProyectos(e.target.value);
                }}
              >
                <MenuItem value="">-- Seleccione --</MenuItem>
                {listaInmobiliariasFormateada.map((inmo, idx) => (
                  <MenuItem key={inmo.value || idx} value={inmo.value}>
                    {inmo.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {(!isEdit || (usuario && !usuario.password)) && (
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Contraseña"
              name="Password"
              type={showPassword ? "text" : "password"}
              value={values.Password || ""}
              onChange={handleChange}
              error={touched.Password && Boolean(errors.Password)}
              helperText={touched.Password && errors.Password}
              variant="outlined"
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        )}
      </Grid>

      {/* Proyectos Checkboxes for Agente (5) */}
      {values.TipoCuenta === 5 && values.InmobiliariaId && (
        <Grid container spacing={1} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Proyectos inmobiliarios asignados:
            </Typography>
          </Grid>
          {proyectosData.length > 0 ? (
            proyectosData.map((proj) => {
              const isChecked =
                Array.isArray(values.ProyectosInmobiliariosId) &&
                values.ProyectosInmobiliariosId.includes(proj.value);
              return (
                <Grid item xs={12} sm={4} key={proj.value}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={(e) =>
                          handleCheckProyecto(proj.value, e.target.checked)
                        }
                        color="success"
                      />
                    }
                    label={proj.label}
                  />
                </Grid>
              );
            })
          ) : (
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                No hay proyectos asociados a esta inmobiliaria.
              </Typography>
              <Button
                variant="outlined"
                color="success"
                size="small"
                onClick={() => window.open("/proyectos/agregar", "_blank")}
              >
                Crear Proyecto
              </Button>
            </Grid>
          )}
        </Grid>
      )}

      {/* Datos Bancarios Section */}
      <Typography variant="h6" sx={{ mt: 4, mb: 2, color: "#333", fontWeight: 600 }}>
        Datos Bancarios
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="banco-label">Banco</InputLabel>
            <Select
              labelId="banco-label"
              name="Banco"
              value={values.Banco || ""}
              label="Banco"
              onChange={handleChange}
            >
              {opcionesBanco.map((b) => (
                <MenuItem key={b.value} value={b.value}>
                  {b.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="tipo-cuenta-bancaria-label">
              Tipo Cuenta Bancaria
            </InputLabel>
            <Select
              labelId="tipo-cuenta-bancaria-label"
              name="TipoCuentaBancaria"
              value={values.TipoCuentaBancaria || ""}
              label="Tipo Cuenta Bancaria"
              onChange={handleChange}
            >
              {opcionesTipoCuentaBancaria.map((t) => (
                <MenuItem key={t.value} value={t.value}>
                  {t.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="medio-pago-label">Medio Pago</InputLabel>
            <Select
              labelId="medio-pago-label"
              name="MedioPago"
              value={values.MedioPago || ""}
              label="Medio Pago"
              onChange={handleChange}
            >
              {opcionesMedioPago.map((m) => (
                <MenuItem key={m.value} value={m.value}>
                  {m.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Número de cuenta"
            name="NumeroCuenta"
            value={values.NumeroCuenta || ""}
            onChange={handleChange}
            variant="outlined"
            size="small"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FormUsuarioFields;
